import { ResponsePaginado } from '../../../types'
import {
  AprovarValidacaoCicloApibody,
  AprovarValidacaoResponse,
  ExecucaoCiclo,
  HistoricoExecucaoCicloResponse,
  ObterExecucoesCicloApiQuery
} from '../../../types/execucaoCicloTypes'
import { ManualApiPayload, NovoCicloAutomacao } from '../../../types/ciclosApiType'
import automacaoService from './automacaoService'

const listarExecucoesCicloApi = async (query: ObterExecucoesCicloApiQuery): Promise<ResponsePaginado<ExecucaoCiclo>> =>
  automacaoService.listarExecucoesCicloApi(query)

const aprovarValidacaoCicloApi = async (body: AprovarValidacaoCicloApibody): Promise<AprovarValidacaoResponse> =>
  automacaoService.aprovarValidacaoCicloApi(body)

const gerarArquivoManual = async (parceiroId: string | number, payload: ManualApiPayload): Promise<NovoCicloAutomacao> =>
  automacaoService.gerarArquivoManual(parceiroId, payload)

const listarHistoricoExecucaoCicloApi = async (cicloId: number): Promise<HistoricoExecucaoCicloResponse[]> =>
  automacaoService.listarHistoricoExecucaoCicloApi(cicloId)

export default {
  listarExecucoesCicloApi,
  aprovarValidacaoCicloApi,
  gerarArquivoManual,
  listarHistoricoExecucaoCicloApi
}
